import React from "react";
import UploadResume from "../../Common/UploadResume/UploadResume";

export default function ApplyJobConfirm({
  setFirst,
  handleConfirm,
  applying,
  closeIt,
}) {
  return (
    <div className="apply-job-confirm-wrapper">
      <header className="ajcw-header">
        <span />
        <h6>Apply for job</h6>
        <span onClick={() => closeIt()}>x</span>
      </header>
      <div className="ajcw-body">
        <div className className="ajcw-extra">
          <img src="https://img.icons8.com/ios/150/ff0000/info--v1.png" />
          <p>
            Cover letter is optional but including it, increases the opportunity
            to get shortlisted
          </p>
        </div>
        <div className="ajcw-cover-wrapper">
          <p>
            Cover letter<span>(Max 100 words)</span>
          </p>

          <textarea
            rows="8"
            placeholder="Type your cover letter here"
          ></textarea>
        </div>
        {/* <UploadResume /> */}
        <div className="ajcw-resume">
          <p>
            Drag & Drop or browse to upload your updated resume (Only docs & pdf
            max upto 5 MB)
          </p>
          <div className="ajcw-file">
            <div>
              <img src="https://img.icons8.com/color/48/000000/pdf-2--v1.png" />
              <span>Resume</span>
            </div>
            <p>Remove</p>
          </div>
        </div>
        <button onClick={() => handleConfirm()} className="apply-button">
          {applying ? "Applying..." : "Apply now"}
        </button>
      </div>
    </div>
  );
}
